const getChannelPageLayout =
  (pageWidth: number) => (_: unknown, index: number) => ({
    length: pageWidth,
    offset: pageWidth * index,
    index,
  });

export default getChannelPageLayout;
